import React, {useState} from 'react';
import Box from '@material-ui/core/Box';
import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import Button from '@material-ui/core/Button';
import {Row} from '@deere/ux.uxframe-react';
import Paper from '@material-ui/core/Paper';
import styles from './index.css';
import StatusDashboardStepper from './../StatusDashboardStepper/index';
import {EmptyStateLayout} from './../EmptyPage/index';
import StatusColorIndicator from './statusColorIndicator';
import DownloadSignedDocuments from './downloadSignedDocuments';
import {SpinnerIcon} from '../../Icon';
import {CreateEnvelopButton} from './CreateEnvelopButton';
import {FormattedMessage, useIntl} from 'react-intl';
import {envelopeStatusMap} from '../../../mappers/translationMappers';
import {DocumentInfoPopup} from '../document-info-popup';
import {EnvelopeSummaryDocuments} from '../EnvelopeSummary/envelopeSummaryDocuments';
import {PrimaryQuoteInfoIcon} from './PrimaryQuoteInfoIcon';
import PropTypes from 'prop-types';


const formatStringCase = (str) => {
    if (typeof str !== 'string') return ''
    return str.charAt(0).toUpperCase() + str.slice(1)
}


const getDateTime = (date) => {
    return (new Date(date).toLocaleDateString())
}

const envelopeStatusColors = {
    sent: '#ffb000', //yellow-sea
    declined: '#c21020', //red
    completed: '#367c2b', //green
    noEnvelope: '#C0C0C0' //silver-grey
}

export default function CollapsibleRow(props) {

    const {handleGetStatus, row, userBranchCode, userHasAccessToERegistry} = props;
    const [open, setOpen] = React.useState(Boolean(row.newEnvelope));
    const intl = useIntl()

    return (
        <React.Fragment>
            <TableRow style={{
                'borderLeft': `15px solid ${row.envelopes !== null && row.envelopes.length > 0
                    ? envelopeStatusColors[row.envelopes[0].Status] : envelopeStatusColors['noEnvelope']}`
            }} variant="outlined">
                <TableCell width="5%">
                    {row.envelopes !== null && row.envelopes.length > 0 ?
                        <IconButton aria-label="expand row" onClick={() => setOpen(!open)} size="small">
                            {open ? <KeyboardArrowUpIcon/> : <KeyboardArrowDownIcon/>}
                        </IconButton> : null}
                </TableCell>
                <TableCell component="th" scope="row" width="8%">{row.bundleNumber}</TableCell>
                <TableCell align="left" width="8%">
                    <div className={styles.primaryQuoteIcon}>
                        {row.quoteNumber}
                        <PrimaryQuoteInfoIcon
                            row={row}
                        />
                    </div>
                </TableCell>
                <TableCell align="left" width="11%">{getDateTime(row.startDate)}</TableCell>
                <TableCell align="left" width="19%">{row.alfaDealerName}</TableCell>
                <TableCell align="left" data-sl="mask">{row.primaryCustomer}</TableCell>
                <TableCell align="left"
                    width="16%">{row.salesPersonName.split(' ').map(s => s[0] + s.slice(1).toLowerCase()).join(' ')}</TableCell>
                <TableCell align="left" width="19%">
                    <CreateEnvelopButton
                        row={row}
                        userBranchCode={userBranchCode}
                    />
                </TableCell>
            </TableRow>
            <TableRow>
                <TableCell colSpan={12} style={{padding: 0}}>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        {row.envelopes !== null && row.envelopes.length > 0 ?
                            row.envelopes.map(
                                envelopeData => {
                                    const [documentInfoPopupStatus, setDocumentInfoPopupStatus] = useState(false);

                                    const handleDocumentPopup = (event) => {
                                        event.preventDefault();
                                        setDocumentInfoPopupStatus(true);
                                    };
                                    const [spinnerOn, setSpinnerOn] = React.useState(false);

                                    return (

                                        <Paper className={styles.paper} elevation={1}
                                            key={envelopeData.envelopeDetail.envelopeId}
                                            style={{}}>
                                            <Row className="d-flex flex-wrap justify-content-around"
                                                style={{paddingTop: 20}}>
                                                <p
                                                    className="d-inline font-weight-bold pt-1">{intl.formatMessage({id: 'labels.ENVELOPE_ID'}) + ': '}
                                                    <span
                                                        className="font-weight-normal">{envelopeData.envelopeDetail.envelopeId}</span>
                                                </p>
                                                <p
                                                    className="d-inline font-weight-bold pt-1">{intl.formatMessage({id: 'labels.STATUS_DATE'}) + ': '}
                                                    <span
                                                        className="font-weight-normal">{getDateTime(envelopeData.envelopeDetail.lastModifiedAt)}</span>
                                                </p>
                                                <p className="d-inline font-weight-bold pt-1">{intl.formatMessage({id: 'labels.STATUS'}) + ': '}
                                                    <span
                                                        className="font-weight-normal">{formatStringCase(envelopeData.envelopeDetail.status && intl.formatMessage({id: envelopeStatusMap[envelopeData.envelopeDetail.status.toUpperCase()]}))}</span>
                                                </p>

                                                <Box className="d-inline" justifyContent="flex-end"
                                                    key={envelopeData.envelopeDetail.envelopeId + '-box'}>
                                                    {spinnerOn
                                                        ? (
                                                            <span className="font-italic text-success">
                                                                <FormattedMessage id={'labels.UPDATING_STATUS'}/>... <SpinnerIcon size="sm"/>
                                                            </span>
                                                        )
                                                        : (
                                                            <Button
                                                                onClick={() => handleGetStatus(envelopeData.envelopeDetail.envelopeId, row.quoteNumber, setSpinnerOn)}
                                                                size="small" style={{backgroundColor: '#ffde00'}}
                                                                variant="contained">
                                                                <FormattedMessage id={'labels.GET_STATUS'}/>
                                                            </Button>
                                                        )
                                                    }
                                                </Box>
                                            </Row>
                                            {
                                                envelopeData.envelopeDetail.signers
                                                && (<StatusDashboardStepper
                                                    bgColor={'#fafafa'}
                                                    envelopeId={envelopeData.envelopeDetail.envelopeId}
                                                    envelopeStatus={envelopeData.envelopeDetail.status}
                                                    signersList={envelopeData.envelopeDetail.signers}/>)
                                            }

                                            <Row className="d-flex justify-content-between ml-20">
                                                <DownloadSignedDocuments
                                                    bundleNumber={row.bundleNumber}
                                                    documentsInEnvelope={envelopeData.documents}
                                                    envelopeId={envelopeData.envelopeDetail.envelopeId}
                                                    envelopeStatus={envelopeData.envelopeDetail.status}
                                                    icsID={row.icsID}
                                                    quoteNumber={row.quoteNumber}
                                                    userBranchCode={userBranchCode}
                                                    userHasAccessToERegistry={userHasAccessToERegistry}
                                                />

                                                <div className={styles.documentInfoPopup} onClick={handleDocumentPopup}>
                                                    <EnvelopeSummaryDocuments
                                                        documentName={<FormattedMessage
                                                            id={'labels.SELECTED_DOCUMENTS'}/>}
                                                    />
                                                </div>

                                                <StatusColorIndicator/>
                                            </Row>
                                            <DocumentInfoPopup
                                                documents={envelopeData.documents}
                                                isHidden={documentInfoPopupStatus}
                                                setDocumentInfoPopupStatus={setDocumentInfoPopupStatus}
                                            />
                                        </Paper>)
                                }
                            ) : (<EmptyStateLayout context={<FormattedMessage id={'alerts.NO_ENVELOPE_FOUND'}/>}/>)}
                    </Collapse>
                </TableCell>
            </TableRow>
        </React.Fragment>
    );
}
CollapsibleRow.propTypes = {
    handleGetStatus: PropTypes.func.isRequired,
    row: PropTypes.object.isRequired,
    userBranchCode: PropTypes.string.isRequired,
    userHasAccessToERegistry: PropTypes.bool.isRequired
};
